import React, { FunctionComponent, ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { useMedia } from 'react-media-match';
import StyledPaybackIcon from '../icons/Payback';

const StyledPayback = styled.div<{ mobile: boolean }>`
  color: #0046aa;
  font-size: 0.75rem;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: row nowrap;
  margin: ${({ mobile }) => (mobile ? '1.5rem auto;' : '1rem auto;')};
`;

const Icon = styled(StyledPaybackIcon)`
  margin-right: 0.75rem;
`;

export interface PaybackLabelProps {
  /** The payback points. */
  points: string;
}

/**
 * This is the payback label component. If the current product has payback points available this
 * component renders the given amount of payback points.
 */
export const PaybackLabel: FunctionComponent<PaybackLabelProps> = ({ points }): ReactElement => {
  const isMobile = useMedia({ desktop: false, mobile: true, tablet: false });

  return (
    <StyledPayback data-testid="payback" mobile={isMobile}>
      <Icon />
      <FormattedMessage
        id="payback.points"
        defaultMessage="{value} PAYBACK {value, plural, one {Punkt} other {Punkte}}"
        values={{ value: points }}
      />
    </StyledPayback>
  );
};

export default PaybackLabel;
